<div class="view-container">
<div  class="tandcs-view">
    <mat-card class="ui-wrapper">
        <mat-card-title>Terms and conditions</mat-card-title>
        <div>
                <mat-form-field appearance="outline">
                    <textarea readonly [rows]="30" [value]="text" matInput></textarea>
                  </mat-form-field>
        </div>
        <mat-card-actions align="end">
            <button mat-raised-button color="primary" routerLink="/">
                <mat-icon>done</mat-icon> Accept
            </button>
        </mat-card-actions>
    </mat-card>
</div>
</div>
